import SearchHighlight from "components/SearchHighlight";
import Link from "ds/components/Link";
import Typography, { TypographyProps } from "ds/components/Typography";
import { DataAttributes } from "types/DataAttributes";

type ListEntitiesItemLinkUrlProps = {
  href: string;
};

type ListEntitiesItemLinkProps = ListEntitiesItemLinkUrlProps &
  DataAttributes & {
    title: string;
    titleTag?: TypographyProps["tag"];
    titleColor?: TypographyProps["color"];
    searchQuery?: string;
    onClick?: () => void;
  };

const ListEntitiesItemLink = ({
  title,
  href,
  titleTag = "span",
  titleColor,
  searchQuery,
  onClick,
  ...dataAttributes
}: ListEntitiesItemLinkProps) => {
  return (
    <Link variant="secondary" href={href} onPress={onClick} {...dataAttributes}>
      <Typography variant="p-t7" tag={titleTag} color={titleColor}>
        {searchQuery ? <SearchHighlight fullText={title} searchQuery={searchQuery} /> : title}
      </Typography>
    </Link>
  );
};

export default ListEntitiesItemLink;
